import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'cm-continue-modal',
    templateUrl: './cm-continue-modal.component.html',
    styleUrls: ['./cm-continue-modal.component.scss'],
    standalone: false
})
export class CmContinueModalComponent implements OnInit {
	constructor(public dialogRef: MatDialogRef<CmContinueModalComponent>) {}

	ngOnInit() {}
}
